import { APIModel } from "./api-model";

export class FinalDisposition extends APIModel {
  id: string;
  code:string;
  note: string;

  static fieldsToMap = {
    direct: [
      'id',
      'code',
      'note'
    ]
  }

  static buildFromAPI(record: any): FinalDisposition {
    const row = new FinalDisposition();
    record = record || {};

    this.mapFieldsDirectly<FinalDisposition>(FinalDisposition.fieldsToMap.direct, record, row);

    return row;
  }
}